/**
 * Contact Form Hook
 *
 * Provides functionality to submit the contact form.
 */

import { useAction } from 'convex/react';
import { api } from '@have-done/backend/convex/_generated/api';

export type ContactTopic = 'support' | 'feedback' | 'business' | 'other';

export interface ContactFormData {
  name: string;
  email: string;
  topic: ContactTopic;
  message: string;
}

/**
 * Hook to submit the contact form
 */
export function useSubmitContactForm() {
  return useAction(api.contact.submitContactForm);
}
